query hoppermationSenders($companyId: ID!) {
  senders: hoppermationSenders(companyId: $companyId) {
    id
    isVerified
    isDefault
    isAcknowledged
    fromEmail
    replyToEmail
    name
  }
}
